/** Class on the chat's render root — anchors Mantine CSS variables when the chat lives in a shadow root. */
export const ATLAS_CHAT_ROOT_CLASS = 'atlas-chat-root';

/**
 * `globalThis` key the library bundle pushes its CSS chunks onto at module
 * load. The inject hook in `vite.lib.config.ts` writes to it; `adoptStyles`
 * reads from it when a chat mounts into a shadow root.
 */
export const CSS_REGISTRY_KEY = 'atlasChatCssRegistry';

/** CSS chunks registered by the library bundle, in load order. Empty outside the lib build. */
export function getRegisteredCss(): string[] {
  const registry = (globalThis as Record<string, unknown>)[CSS_REGISTRY_KEY];
  return Array.isArray(registry) ? (registry as string[]) : [];
}
